<script>
import {h, resolveComponent} from 'vue';
import _ from 'lodash';
import ECharts from 'vue-echarts';
import 'echarts/lib/chart/bar';
import 'echarts/lib/component/tooltip';

import {CHART} from '@/components/constants/chart';
import widgetWrapper from '@/components/widgets/common/widgetWrapper';

export default {
  name: 'widgetChartBar',
  components: {widgetWrapper, 'v-chart': ECharts},
  emits: ['more'],
  render() {
    const {items} = this;
    const {title, subtitle, dateItem, more, info} = items;
    const vChart = resolveComponent('v-chart');
    const widgetWrapper = resolveComponent('widget-wrapper');
    const widgetChartBar = h(vChart, {
      autoresize: true,
      option: this.buildOption(),
      style: [{width: '100%', height: '100%'}]
    });

    return h(
        widgetWrapper,
        {
          title,
          subtitle,
          dateItem,
          more,
          info,
          onMore: (more) => {
            this.$emit('more', more);
          }
        },
        () => [widgetChartBar]
    );
  },
  props: {
    items: {
      type: Object,
      default: () => {
      }
    }
  },
  methods: {
    buildOption() {
      const {$theme, items} = this;

      const series = this.items.data.map((seriesData, idx) => ({
        value: seriesData,
        name: items.xAxisData[idx],
        itemStyle: {
          color: this.items.data.length - 1 === idx ? $theme.COLOR.CHART[0] : $theme.COLOR.UI.UI07
        }
      }));

      const option = {
        xAxis: [{data: items.xAxisData}],
        series: {data: series}
      };

      return _.merge({}, CHART.CHART_BAR, option);
    }
  }
};
</script>

<style scoped lang="scss">
.widget-chart-bar {
  height: 100%;
  margin: 0 auto;
  padding: 20px;
}
</style>
